import { useContext } from 'react';
import ConfigurationContext from '../Contexts/ConfigurationContext';
import { ConfigurationData } from '../Types/ConfigurationData';

function useConfigurationData() {
    const { configurationData } = useContext(ConfigurationContext);

    const getConfigurationData = (key: string, businessUnitId: number | null): ConfigurationData | null => {

        if (!configurationData) {
            return null;
        }

        let matchingConfigData = configurationData.find((cd: ConfigurationData) => cd.name === key && cd.businessUnitId === businessUnitId);

        if (!matchingConfigData) {

            matchingConfigData = configurationData.find((cd: ConfigurationData) => cd.name === key && cd.businessUnitId === null);
        }

        if (!matchingConfigData) {
            return null;
        }

        return matchingConfigData;
    }

    const getConfigurationDataBoolean = (key: string, businessUnitId: number | null, defaultValue: boolean): boolean => {

        let matchingConfigData = getConfigurationData(key, businessUnitId);

        if (matchingConfigData === null) {
            return defaultValue;
        }

        let valueAsBoolean = matchingConfigData?.value.toUpperCase() === "TRUE" ? true : false;

        return valueAsBoolean;
    }

    return { getConfigurationData, getConfigurationDataBoolean };
}

export default useConfigurationData;
